<template>
    <main-menu></main-menu>
</template>

<script>
    export default {
        name: "Header",
        computed: {
            userData() {
                console.log(this.$store.getters.getUserData);
                return this.$store.getters.getUserData;
            },
        }
    }
</script>

<style lang="scss" scoped>

    #header {
        .header-avatar {
            width: 50px;
        }

        .header-btns {
            padding: 30px 15px;
        }
    }

</style>
